import React, { useState } from 'external/react';
import PropTypes from 'external/prop-types';
import { Button } from 'external/react-bootstrap';
import Icon from './Icon';

export const PDFExportButton = ({
  baseUrl,
  namespace,
  params,
  title = 'Exportieren',
  fileName = 'Export',
  allowExport,
  label,
  ...rest
}) => {
  const [ loading, setLoading ] = useState(false);

  const download = (url, fileName) => () => {
    if (allowExport === undefined || (allowExport())) {
      setLoading(true);
      fetch(url)
        .then(res => {
          if (!res.ok) {
            throw new Error('Download fehlgeschlagen! Status: ' + res.status);
          }
          return res.blob();
        })
        .then(blob => {
          if (navigator.msSaveBlob) {
            navigator.msSaveBlob(blob, fileName + '.pdf');
          } else {
            const link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = fileName;
            link.click();
          }
        })
        .catch(err => {
          window.alert(err);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  };

  let exportUrl = baseUrl;
  if (params) {
    Object.keys(params).forEach(key => {
      const value = params[key];
      if (value) {
        exportUrl += `&_${namespace}_${key}=${value}`;
      }
    });
  }

  const downloadUrl = `/o/pdf-renderer?url=${encodeURIComponent(exportUrl)}&download=true`;
  fileName = fileName.replace(/ /g, '_') + '.pdf';

  return (
    <Button
      title={title}
      download={fileName}
      onClick={download(downloadUrl, fileName)}
      disabled={loading}
      {...rest}
    >
      {!loading && <Icon name="download" title={title}/>}
      {loading && <i className="fa fa-spinner fa-spin"/>}
      {label && label.length > 0 && <span className="ml-3">{label}</span>}
    </Button>
  );
};

PDFExportButton.propTypes = {
  baseUrl: PropTypes.string.isRequired,
  namespace: PropTypes.string.isRequired,
  title: PropTypes.string,
  label: PropTypes.string,
  fileName: PropTypes.string,
  params: PropTypes.object,
  allowExport: PropTypes.func,
};



// WEBPACK FOOTER //
// ./js/components/PDFExportButton.jsx